import {
  createStyles,
  makeStyles,
  Theme,
  useMediaQuery
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const drawerWidth = 280;

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex"
    },
    drawer: {
      [theme.breakpoints.up("md")]: {
        width: drawerWidth,
        flexShrink: 0
      }
    },
    appBar: {
      "@media print": {
        display: "none"
      },
      minHeight: 40,
      zIndex: 1201 //dialogs have 1300 and they need to be in front
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    },
    navLink: {
      "&.active .activeMark": {
        position: "absolute",
        height: "100%",
        width: "0.3rem",
        left: 0
      }
    },
    // necessary for content to be below app bar
    drawerPaper: {
      width: drawerWidth
    },
    content: {
      flexGrow: 1,
      overflowY: "auto",
      overflowX: "hidden",
      backgroundColor: grey["50"],
      [theme.breakpoints.up("md")]: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        backgroundColor: theme.palette.success
      }
    },

    nested: {
      paddingLeft: theme.spacing(4)
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },
    text: {
      fontWeight: 500,
      fontSize: "1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.85rem"
      }
    },
    menuText: {
      fontSize: "0.75rem"
    },
    toolbar: {
      minHeight: 40,
      [theme.breakpoints.up("sm")]: {
        minHeight: 40
      }
    }
  })
);
